import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeOutletComponent } from './change-outlet.component';
import {TranslateSharedLazyModule} from "../../../app-shared/modules/translate-shared-lazy.module";
import {AppSharedModule} from "../../../app-shared/app-shared.module";
import {ChangeUserFormModule} from "../../../app-shared/components/change-user-form/change-user-form.module";
import {FieldSelectInputModule} from "../../../app-shared";
import {OutsideClickModule} from "../../../app-shared/directives/outside-click.module";
import {ChangeOutletCoreComponent} from "./components/change-outlet-core.component";

@NgModule({
  declarations: [ChangeOutletComponent, ChangeOutletCoreComponent],
  imports: [
    CommonModule,
    TranslateSharedLazyModule,
    AppSharedModule,
    ChangeUserFormModule,
    FieldSelectInputModule,
    OutsideClickModule
  ],
  exports: [ChangeOutletComponent, ChangeOutletCoreComponent],
})
export class ChangeOutletModule {}
